/**
 * Fait : la garde contre les réponses PÉRIMÉES — quand un écran change de
 *   ressource (de projet, de fil), l'appel de la ressource quittée peut
 *   revenir APRÈS celui de la nouvelle et écraser son état. L'écran
 *   ressuscitait alors ce qu'on venait de quitter, parfois un projet auquel
 *   on n'a plus droit.
 *
 *   Défaut RÉEL, traqué à la sortie de la phase 5 : il faisait échouer un
 *   témoin de navigateur une fois sur quatre, et un membre qui navigue vite
 *   le verrait. Les deux écrans concernés partagent donc la même garde,
 *   plutôt que chacun la sienne — la porte jumelle se ferme une fois.
 *
 * Ne fait pas : elle n'annule aucune requête (l'appel part et finit, on
 *   ignore seulement sa réponse) et ne connaît rien du contenu chargé.
 */

import { useRef } from 'react';

/** Ce que la garde rend : de quoi tamponner l'aller, et juger le retour. */
export interface GardeDeFraicheur {
  /** La ressource demandée À CET INSTANT — à capturer avant l'appel. */
  readonly demandee: string;

  /** Cette réponse vaut-elle encore ? Faux si l'écran a changé entre-temps. */
  encoreValable(pour: string): boolean;
}

/**
 * Suit la ressource affichée et dit si une réponse est encore d'actualité.
 *
 * Usage : capturer `demandee` AVANT l'appel, et vérifier `encoreValable`
 * APRÈS — avant de toucher le moindre état.
 */
export function useFraicheur(ressourceId: string): GardeDeFraicheur {
  const courante = useRef(ressourceId);
  courante.current = ressourceId;

  return {
    demandee: ressourceId,
    encoreValable: (pour) => courante.current === pour,
  };
}
